import React from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

import { Title, HelperText, Panel } from '../../../account/account-settings.styled';
import { Input, OnboardBtn } from '../../../profile/profile.styled';
import { VSpace } from '../../../account/account-settings';
import {
  Overlay,
  ModalShell,
  Dialog,
  Field,
  Label,
  ActionBar,
  CancelBtn,
  InputWithToggle,
  InputWrap,
  EyeToggle,
} from './change-email.styled';

import { useChangeEmailModal } from './change-email.hooks';
import { COLORS } from '../../../../header/header.styled';

export type ChangeEmailModalProps = {
  open: boolean;
  initialEmail?: string;
  onClose: () => void;
  onSave: (payload: { email: string; currentPassword: string }) => void | Promise<void>;
};

const ChangeEmailModal: React.FC<ChangeEmailModalProps> = (props) => {
  const { open, onClose } = props;

  const {
    panelRef,
    email,
    setEmail,
    password,
    setPassword,
    showPwd,
    handleTogglePasswordVisibility,
    error,
    saving,
    disabled,
    handleSave,
  } = useChangeEmailModal(props);

  if (!open) return null;

  return (
    <>
      <Overlay onClick={onClose} />
      <ModalShell aria-modal="true" role="dialog" aria-labelledby="change-email-title">
        <Dialog ref={panelRef}>
          <Panel as="section" aria-labelledby="change-email-title">
            <Title id="change-email-title">Change email</Title>

            <VSpace $h={16} />

            <form onSubmit={handleSave} autoComplete="off" spellCheck={false}>
              <div style={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                <Field>
                  <Label htmlFor="new-email">New email address</Label>
                  <Input
                    id="new-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="name@company.com"
                    aria-required
                  />
                </Field>

                <Field>
                  <Label htmlFor="current-password">Current password</Label>
                  <InputWrap>
                    <InputWithToggle
                      id="current-password"
                      type={showPwd ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      aria-required
                      $hasToggle
                    />
                    <EyeToggle
                      type="button"
                      aria-label={showPwd ? 'Hide current password' : 'Show current password'}
                      aria-pressed={showPwd}
                      aria-controls="current-password"
                      onClick={handleTogglePasswordVisibility}
                    >
                      {showPwd ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                    </EyeToggle>
                  </InputWrap>
                  {error && <HelperText role="alert">{error}</HelperText>}
                </Field>

                <ActionBar>
                  <CancelBtn
                    style={{ color: `${COLORS.textMuted}`, width: '83px' }}
                    type="button"
                    onClick={onClose}
                  >
                    Cancel
                  </CancelBtn>
                  <OnboardBtn
                    style={{ width: '134px', height: '44px' }}
                    type="submit"
                    disabled={disabled}
                    aria-label="Save new email"
                  >
                    {saving ? 'Saving…' : 'Save changes'}
                  </OnboardBtn>
                </ActionBar>
              </div>
            </form>

            <VSpace $h={16} />
          </Panel>
        </Dialog>
      </ModalShell>
    </>
  );
};

export default ChangeEmailModal;
